import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarYearsListFn = /* @__PURE__ */ createRecipe('calendar-years-list', {}, [])

const calendarYearsListVariantMap = {}

const calendarYearsListVariantKeys = Object.keys(calendarYearsListVariantMap)

export const calendarYearsList = /* @__PURE__ */ Object.assign(memo(calendarYearsListFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarYearsList',
  __getCompoundVariantCss__: calendarYearsListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarYearsListVariantKeys,
  variantMap: calendarYearsListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarYearsListVariantKeys)
  },
  getVariantProps: calendarYearsListFn.getVariantProps,
})